import React from 'react'
import services_1_img from './static/img/Services_item_1.jpg'
import services_2_img from './static/img/Services_item_2.jpg'
import services_3_img from './static/img/Services_item_3.jpg'
import services_4_img from './static/img/Services_item_4.jpg'
import services_5_img from './static/img/Services_item_5.jpg'
import services_6_img from './static/img/Services_item_6.jpg'
import { Link } from 'react-router-dom'

function OurServicesSection(props) {
  return (
    <div className="our_services_section active">
            <div className="our_services_title">
                <h2>Our Services</h2>
            </div>
            <div className="our_services_inner_wrapper">
                <div className="flip_cards_row">
                    <div className="flip_card_container">
                        <div className="flip_card">
                            <Link to={props.routes.service_1.path + '#content_section'} onClick={()=>{props.setCurrentPage('services')}}>
                                <div className="front_side">
                                    <img src={services_1_img} alt="" />
                                    <span className="front_side_description">ENTERPRISE ECOLOGICAL PASSPORT</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="flip_card_container">
                        <div className="flip_card">
                            <Link to={props.routes.service_2.path + '#content_section'} onClick={()=>{props.setCurrentPage('services')}}>
                                <div className="front_side">
                                    <img src={services_2_img} alt="" />
                                    <span className="front_side_description">ENTERPRISE ECOLOGICAL PASSPORT</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="flip_card_container">
                        <div className="flip_card">
                            <Link to={props.routes.service_3.path + '#content_section'} onClick={()=>{props.setCurrentPage('services')}}>
                                <div className="front_side">
                                    <img src={services_3_img} alt="" />
                                    <span className="front_side_description">DRAFT OF PERMISSIBLE DISCHARGE NORMS</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="flip_cards_row">
                    <div className="flip_card_container">
                        <div className="flip_card">
                            <Link to={props.routes.service_4.path + '#content_section'} onClick={()=>{props.setCurrentPage('services')}}>
                                <div className="front_side">
                                    <img src={services_4_img} alt="" />
                                    <span className="front_side_description">DRAFT OF MAXIMUM PERMISSIBLE DISCHARGE</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="flip_card_container">
                        <div className="flip_card">
                            <Link to={props.routes.service_5.path + '#content_section'} onClick={()=>{props.setCurrentPage('services')}}>
                                <div className="front_side">
                                    <img src={services_5_img} alt="" />
                                    <span className="front_side_description">ENVIROMENT PROTECTION</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="flip_card_container">
                        <div className="flip_card">
                            <Link to={props.routes.service_6.path + '#content_section'} onClick={()=>{props.setCurrentPage('services')}}>
                                <div className="front_side">
                                    <img src={services_6_img} alt="" />
                                    <span className="front_side_description">PRODUCTION OF WASTE PASSPORTS</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default OurServicesSection